import { type JSX } from "react";
import { Navigate } from "react-router-dom";

import { useAuth } from "../../hooks";

function ProtectedRoute({ children }: { children: JSX.Element }) {
  const { isAuthenticated } = useAuth();

  return isAuthenticated ? children : <Navigate to="/login" replace />;
}

export default ProtectedRoute;